// src/store/index.js
import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./Auth/authSlice";
import recordedContactReducer from "./RecordedContacts/recordedContactsSlice";
import thirdPartyContactReducer from "./ThirdPartyContacts/thirdPartyContactsSlice";
import notificationsReducer from "./Notifications/notificationsSlice";
import userReducer from "./Users/usersSlice";
import recordedCallReducer from "./RecordedCalls/recordedCallsSlice";
import playlistReducer from "./Playlists/playlistsSlice";
import recordedContactInsightsReducer from "./RecordedContactInsights/recordedContactsInsightsSlice";
import reportReducer from "./Reports/reportsSlice";

export default function createAppStore(initialExtra = {}) {
  const store = configureStore({
    reducer: {
      notifications: notificationsReducer,
      auth: authReducer,
      recordedContacts: recordedContactReducer,
      thirdPartyContacts: thirdPartyContactReducer,
      users: userReducer,
      recordedCalls: recordedCallReducer,
      playlists: playlistReducer,
      recordedContactsInsights: recordedContactInsightsReducer,
      reports: reportReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: initialExtra,
        },
      }),
  });

  // 👇 we will update `store.extra` later in Auth0Initializer
  store.extra = initialExtra;

  return store;
}
